import Auth from './auth'

export const loginGuard = (to, from, next) => {
  const authService = Auth.getInstance()
  if (authService.isAuthenticated) {
    return next({ path: '/' })
  } else {
    return next()
  }
}



// WEBPACK FOOTER //
// ./src/auth/loginGuard.js